import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Dispatch, SearchCriteria } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';

@Injectable({
    providedIn: 'root',
})
export class DispatchService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);

    create(tenantId: string, branchId: string, dispatch: Dispatch): Observable<Dispatch> {
        return this.http.post<Dispatch>(`${this.serviceUtils.getBaseUrl('dispatch', tenantId, branchId)}`, dispatch);
    }

    get(tenantId: string, branchId: string, id: string): Observable<Dispatch> {
        return this.http.get<Dispatch>(`${this.serviceUtils.getBaseUrl('dispatch', tenantId, branchId)}/${id}`);
    }

    update(tenantId: string, branchId: string, dispatch: Dispatch): Observable<Dispatch> {
        return this.http.put<Dispatch>(`${this.serviceUtils.getBaseUrl('dispatch', tenantId, branchId)}`, dispatch);
    }

    search(tenantId: string, branchId: string, criteria: SearchCriteria): Observable<Dispatch[]> {
        return this.http.post<Dispatch[]>(`${this.serviceUtils.getBaseUrl('dispatch', tenantId, branchId)}/search`, criteria);
    }
}
